<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="small">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME" clearable></el-input>
          </el-form-item>
          <el-form-item label="SKU：">
            <el-input size="medium" v-model="searchForm.STANDARD_CODE" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="doQueryTable()" :loading="loadSearch">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" @click="toApplicationSku()" :loading="loadSearch">SKU申请记录</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" @click="toMarryPage()" :loading="loadSearch">供应商SKU匹配</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" @click="toChangeKeep()" :loading="loadSearch">SKU替换记录</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="width: 100%;margin-top:20px">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="STANDARD_CODE" label="标准SKU" min-width="230"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="100"></el-table-column>
          <el-table-column prop="LKD_PRODUCT_CODE" label="霖客达产品编码" min-width="100"></el-table-column>
          <el-table-column prop="LKD_BRAND" label="品牌" min-width="135"></el-table-column>
          <el-table-column prop="LKD_PRODUCT_NAME" label="品名" min-width="90"></el-table-column>
          <el-table-column prop="LKD_SPECIFICATION" label="规格" min-width="150"></el-table-column>
          <el-table-column prop="LKD_UNIT" label="单位" min-width="150"></el-table-column>
          <!-- <el-table-column fixed="right" label="操作" width="250">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="submitPrint(scope.row)">查看</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="供应商选择" center :visible.sync="oneButVisible" width="346px">
          <el-form size="small" :model="oneForm" ref="oneForm">
            <el-form-item label="供应商：">
              <el-select v-model="oneForm.SUPPLIER_ID" placeholder="请选择" clearable>
                <el-option v-for="item in companys" :key="item.SUPPLIER_ID" :label="item.AB_NAME"
                  :value="item.SUPPLIER_ID"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class=" ">
            <el-button size="small" @click="oneButVisible = false">取 消</el-button>
            <el-button size="small" @click="supplierSure">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { supplierList } from 'api/systemSetting';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      oneForm: {
        SUPPLIER_ID: [],
      },
      companys: [],
      oneButVisible: false,
      loadSearch: false,
      formLableWidth: '120px',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      tableData: JSON.parse(sessionStorage.getItem('tableData')) ? JSON.parse(sessionStorage.getItem('tableData')) : [],
      searchForm: JSON.parse(sessionStorage.getItem('searchForm')) ? JSON.parse(sessionStorage.getItem('searchForm')) : { DAY_INTERVAL: [] },
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;

    if (this.ENTRY_SEARCH_DATA_CONDITION.CONDITION) {
      this.searchForm = this.ENTRY_SEARCH_DATA_CONDITION.CONDITION;
      this.currentPage = this.ENTRY_SEARCH_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
    this.querySupplier();
  },
  computed: {
    ENTRY_SEARCH_DATA_CONDITION() {
      return this.$store.state.ENTRY_SEARCH_DATA_CONDITION;
    },
  },
  methods: {
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    doQueryTable() {
      this.currentPage = 1;
      this.queryTable();
      if (this.tableData.length == 0) {
        this.$message.show({ text: '暂无数据', type: 'warning' });
      }
    },
    // 拉取供应商
    querySupplier() {
      const params = {
        PAGEINDEX: 0,
        PAGESIZE: 9999,
      };
      supplierList(params)
        .then((result) => {
          if (result.length !== 0) {
            this.companys = result[0].list;
          } else {
            this.companys = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 选择供应商确认
    supplierSure() {
      if (this.oneForm.SUPPLIER_ID.length === 0) {
        this.$message.show({ text: '请选择供应商', type: 'warning' });
      } else {
        this.oneButVisible = false;
        this.$router.push({ name: 'marryPageSku', params: { supplier_id: this.oneForm.SUPPLIER_ID } });
      }
    },
    // 点击跳转
    toApplicationSku() {
      this.$router.push({ name: 'applicationSku', params: '' });
    },
    toMarryPage() {
      this.oneButVisible = true;
    },
    toChangeKeep() {
      this.$router.push({ name: 'changeKeepSku', params: '' });
    },
    // -------------------------------------进入页面拉取数据
    queryTable() {
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 30,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        // PLATFORM_ID: Number(sessionStorage.getItem('tcId')),
        PLATFORM_ID: 1,
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.STANDARD_CODE) {
        params.STANDARD_CODE = this.searchForm.STANDARD_CODE;
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].SKU_LIST;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_SAVE_QUALIFIC_LIST', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.totalCount = 0;
          this.tableData = [];
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SKUManage/staticSku.vue